module.exports = __webpack_public_path__ + "img/create-order-success.7536e159.svg";